import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { SVGIcon } from 'components/qstrap'
import { mapToCssModules } from './Utils'

const propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  cssModule: PropTypes.object,
  svgIcon: PropTypes.string,
  color: PropTypes.string,
}

export const BoxedLink = (props) => {
  const {
    className,
    cssModule,
    svgIcon,
    name,
    color,
    ...attributes
  } = props

  const classes = mapToCssModules(classNames(
    className,
    'boxed-link',
    {
      [`bold-bg-${color}`]: color,
    }
  ), cssModule)

  return (
    <div {...attributes} className={classes}>
      <div className="link-label">
        <span>{name}</span>
      </div>
      <SVGIcon name={svgIcon} />
    </div>
  )
}

BoxedLink.propTypes = propTypes
